import { Work } from '../types/interfaces'

export const works: Work[] = [
  {
    Name: 'Alfabit',
    Position: 'ITアプリケーションスペシャリスト',
    HowLong: '12.2024 - 現在',
    Tasks: [
      'クライアントおよびビジネス向けのネットワークサービス、アプリケーション、Webサイトのプログラミング。',
      'ワイヤレスおよびクラウドテクノロジーの実装（自動化）。',
      'サーバー管理およびAPI・データベース管理。トラブルシューティングと技術的なカスタマーサポート。',
    ],
  },
  {
    Name: 'Techgroup',
    Position: '通信技術者',
    HowLong: '08.2025 - 09.2025',
    Tasks: [
      '光ファイバーケーブルの敷設と設置。通信ネットワークの保守と維持。',
      'ネットワークデバイスおよび家庭用インターネットネットワークの設定と保守。',
      'ネットワークサービスおよびアプリケーションのプログラミング。',
    ],
  },
  {
    Name: '国立原子力研究センター',
    Position: '原子力機器部門のインターン',
    HowLong: '07.2025 - 08.2025',
    Tasks: [
      '技術文書の作成、検証、および妥当性確認の習熟。',
      'シーメンスおよびベッコフのPLCコントローラーのプログラミングの基礎を学ぶ。',
      'C++およびC#プログラミング言語でのAQURE加速器用ソフトウェアの作成とテスト。',
      '加速器の電気部品の組み立てと試運転。機能テストの実施。',
    ],
  },
  {
    Name: 'Elepotrik',
    Position: '電子サービスのエンジニア',
    HowLong: '08.2024 - 09.2024',
    Tasks: [
      'コンピューターおよびモバイル機器を含む電子デバイスの診断と修理。',
      '電子部品のはんだ付けと交換。診断装置の操作。',
      '機能テストの実施とデバイス内のソフトウェアの修復。',
      '注文の受付と顧客との連絡。',
    ],
  },
  {
    Name: 'Lewe Korki',
    Position: 'プロジェクト創設者、家庭教師、フルスタック開発者',
    HowLong: '07.2023 - 05.2024',
    Tasks: [
      '家庭教師向けの教育プラットフォームの作成と維持、およびそれを通じたクラスの編成。',
      'データベース管理 – ユーザーと教材の整理。',
      '高校生向けの物理学と数学の個別指導。',
    ],
  },
  {
    Name: 'Soulgraphy',
    Position: 'クリエイター兼プロジェクトリーダー、フロントエンド開発者',
    HowLong: '11.2020 - 07.2021',
    Tasks: [
      'ユーザーの見解を分析できる政治テスト用のプラットフォームの作成と開発。',
      '20人のチームの管理、若者の討論会、政治家とのインタビューの開催。',
      '毎日数万回の訪問を達成。',
      'オンラインプラットフォームの存在 – テストは引き続き <a href="https://soulgraphy.me">Soulgraphy</a> で利用可能です。',
    ],
  },
]
